module.exports = __webpack_public_path__ + "static/media/dsna_logo.6221ad55.png";